(() => {
  const SELECTOR = '.sg-free-ship';
  let isUpdatingLock = false; // 智能状态锁：防止并发递归与死循环
  let debounceTimeout = null;

  // Safe money formatter
  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        const fmt = (window.theme && window.theme.moneyFormat) || (window.Shopify.money_format) || '${{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    const v = (cents / 100).toFixed(2);
    return `$${v}`;
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return res.json();
  }

  function updateWidgets(cart) {
    const widgets = document.querySelectorAll(SELECTOR);
    if (!widgets.length) return;

    widgets.forEach((el) => {
      const threshold = parseInt(el.getAttribute('data-threshold') || '0', 10);
      const msgEl = el.querySelector('.sg-free-ship__msg');
      const fillEl = el.querySelector('.sg-free-ship__bar-fill');

      if (!threshold || !msgEl || !fillEl) return;

      const total = cart?.total_price ?? 0; // cents
      const remaining = Math.max(threshold - total, 0);
      const progress = Math.max(0, Math.min(100, (total / threshold) * 100));

      // 性能优化：只有数据真正改变时才修改 DOM，防止产生无意义的网页震荡
      const newText = remaining > 0 
        ? `You're only ${formatMoney(remaining)} away from FREE shipping — add one more item!`
        : `✅ FREE shipping unlocked — you're saving on shipping!`;
      const newWidth = `${progress}%`;

      if (msgEl.textContent !== newText) msgEl.textContent = newText;
      if (fillEl.style.width !== newWidth) fillEl.style.width = newWidth;
    });
  }

  async function refresh() {
    if (isUpdatingLock) return; // 如果处于锁定状态，直接熔断，拒绝重复执行
    isUpdatingLock = true;
    
    try {
      const cart = await fetchCart();
      updateWidgets(cart);
    } catch (e) {
      // Silent fail
    } finally {
      // 延迟 200ms 释放锁，给浏览器留出渲染与事件消纳的时间窗口
      setTimeout(() => {
        isUpdatingLock = false;
      }, 200);
    }
  }

  // --- Real-time hooks ---
  // 1) Initial
  document.addEventListener('DOMContentLoaded', refresh);

  // 2) Patch fetch for /cart/* endpoints
  const _fetch = window.fetch;
  window.fetch = function (...args) {
    const p = _fetch.apply(this, args);
    try {
      const url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || '';
      if (url && /\/cart\/(add|change|update|clear)\.js/i.test(url)) {
        p.finally(() => {
          if (!isUpdatingLock) {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(refresh, 150); // 150ms 秒级响应正常用户行为
          }
        });
      }
    } catch (_) {}
    return p;
  };

  // 3) Patch XHR (兼容部分仍在使用旧版 AJAX 的 Shopify 主题组件)
  const XHR = window.XMLHttpRequest;
  if (XHR) {
    const open = XHR.prototype.open;
    const send = XHR.prototype.send;

    XHR.prototype.open = function (method, url, ...rest) {
      this.__sg_cart_url = url;
      return open.call(this, method, url, ...rest);
    };

    XHR.prototype.send = function (...rest) {
      this.addEventListener('loadend', () => {
        try {
          const url = this.__sg_cart_url || '';
          if (/\/cart\/(add|change|update|clear)\.js/i.test(url)) {
            if (!isUpdatingLock) {
              clearTimeout(debounceTimeout);
              debounceTimeout = setTimeout(refresh, 150);
            }
          }
        } catch (_) {}
      });
      return send.call(this, ...rest);
    };
  }

  // 4) 加上智能锁的安全网页监听器
  const mo = new MutationObserver(() => {
    // 拦截非自身引起的第三方 DOM 节点重绘，确保进度条长驻页面
    if (!isUpdatingLock && document.querySelector(SELECTOR)) {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(refresh, 150);
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();